import styled from 'styled-components';
import { COLORS, THEME } from '../../constants/theme';

export const Button = styled.button`
  text-transform: uppercase;
  font-size: 1.4rem;
  letter-spacing: 1px;
  line-height: 2rem;
  border-radius: 4px;
  border: none;
  padding: 12px 20px;
  justify-content: space-between;
  font-family: ${THEME.FONT.face.bold};
  transition: all 250ms ease;
  margin: 1rem;
  display: block;
  cursor: pointer;
  margin-left: auto;
  margin-right: auto;

  &:hover {
    transition: all 150ms ease;

    .icon {
      transform: translateX(0.3rem);
      transition: transform 0.1s cubic-bezier(0.785, 0.135, 0.15, 0.86);
    }
  }

  &:focus,
  &:focus-visible {
    outline: 1px solid ${COLORS.BLUE};
    outline-offset: 2px;
  }

  &.button {
    margin-top: 3rem;

    &--default {
      border-color: ${COLORS.BLACK};

      .button__text {
        border-bottom-width: 2px;
        border-bottom-style: solid;
        border-bottom-color: inherit;
      }

      &:hover {
        color: ${THEME.COLORS.SECONDARY.azure};
        border-color: ${THEME.COLORS.SECONDARY.azure};
      }

      &:disabled {
        color: ${COLORS.GREY_DARK};
        border-color: ${COLORS.GREY_DARK};
      }
    }

    &--primary {
      color: ${COLORS.WHITE};
      background-color: ${THEME.COLORS.SECONDARY.azure};
      fill: ${COLORS.WHITE};

      &:active {
        background-color: ${COLORS.BLACK};
      }

      &:enabled:hover {
        background-color: ${THEME.COLORS.SECONDARY.azureHover};

        .button__icon svg {
          transform: translateX(3px);
          transition: transform 0.1s cubic-bezier(0.785, 0.135, 0.15, 0.86);
        }
      }

      &:disabled {
        background-color: ${THEME.COLORS.GREY.brushedSteel};
      }
    }

    &--secondary {
      border: 1px solid ${THEME.COLORS.GREY.platinumMedium};

      &:active {
        background-color: ${COLORS.BLACK};
        border-color: ${COLORS.BLACK};
        color: ${COLORS.WHITE};
        fill: ${COLORS.WHITE};
      }

      &:hover {
        background-color: ${THEME.COLORS.GREY.platinumMedium};
      }

      &:disabled {
        background-color: ${THEME.COLORS.GREY.mist};
        border-color: ${THEME.COLORS.GREY.platinumMedium};
      }
    }
  }

  .button__icon {
    svg {
      transition: transform 0.1s cubic-bezier(0.785, 0.135, 0.15, 0.86);
      width: 20px;
      height: 6px;
      margin-left: 0.5rem;
      position: relative;
      top: -2px;
    }
  }
`;
